import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useAlert } from "hooks/useAlert";
import { RevivnApiForm } from "components/Form/RevivnApiForm";

const ResetTestInventoriesPage: React.FC = () => {
  const { alertSuccess, alertError } = useAlert();
  const formId = "reset-test-inventories-form";

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Reset Test Inventories
        </Typography>

        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <RevivnApiForm<any, any>
          FormProps={{ id: formId }}
          initialValues={{}}
          action="inventories/reset"
          method="POST"
          onSubmit={() => {}}
          onSuccess={() => {
            alertSuccess("Test inventories have been reset.");
          }}
          onError={(err) => {
            const message = err.response?.data?.error?.message || "An error occurred";
            alertError(`Failed to reset test inventories: ${message}`);
          }}
        >
          <Stack spacing={3}>
            <Box>
              <Button variant="contained" color="primary" type="submit" form={formId}>
                Reset Test Inventories
              </Button>
            </Box>

            <Typography variant="body2" color="text.secondary">
              This will reset the test inventories to the default state.
            </Typography>
          </Stack>
        </RevivnApiForm>
      </Paper>
    </Box>
  );
};

export default ResetTestInventoriesPage;
